import React from 'react';
import { LineaTiempo } from '../compartidos/LineaTiempo';
import { IngresosEgresos } from '../compartidos/IngresosEgresos';
import { Contrapartes } from '../compartidos/Contrapartes';
import { MapaHorarios } from '../compartidos/MapaHorarios';

// D: análisis de la ficha (solo lectura), con el rango de la pestaña Movimientos.
export const ClienteAnalisis = ({ cuit, rango, perfilDeclarado }) => (
  <div className="space-y-5" data-testid="cliente-analisis">
    <p className="text-xs text-slate-500">Rango de la pestaña Movimientos: {rango.desde} a {rango.hasta}. El gráfico mensual muestra los 12 meses que terminan en {rango.hasta}.</p>
    <LineaTiempo cuit={cuit} />
    <IngresosEgresos cuit={cuit} desde={rango.desde} hasta={rango.hasta} perfilDeclarado={perfilDeclarado} />
    <Contrapartes cuit={cuit} desde={rango.desde} hasta={rango.hasta} />
    <MapaHorarios cuit={cuit} desde={rango.desde} hasta={rango.hasta} />
  </div>
);

export default ClienteAnalisis;
